import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import reducers from './reducers';
import * as Sentry from '@sentry/browser';

if (process.env.ENVIRONMENT && process.env.ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: "https://95493f5dec754b4288e2e9855fd3aada@sentry.io/1355177"
  });
}
const store = createStore(combineReducers(reducers), {}, applyMiddleware(ReduxThunk));

ReactDOM.render((
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js